import React from "react";
import axios from "axios";
import Spinner from "../../components/Spinner";
import { Modal } from "../../components/Modal";
import {primaryLabelName, secondaryLabelName, uniqueIdentifier1Name} from "../../utils/helper"

const API = localStorage.getItem("assethost");

function calculateDuration(startDate, endDate) {
  if (startDate && endDate) {
    startDate = new Date(startDate);
    endDate = new Date(endDate);
  } else {
    return "";
  }

  // Ensure startDate <= endDate
  if (startDate > endDate) {
    [startDate, endDate] = [endDate, startDate];
  }

  let years = endDate.getFullYear() - startDate.getFullYear();
  let months = endDate.getMonth() - startDate.getMonth();
  let days = endDate.getDate() - startDate.getDate();

  // Adjust for negative days
  if (days < 0) {
    months--;
    // Get the number of days in the previous month
    const prevMonth = new Date(endDate.getFullYear(), endDate.getMonth(), 0);
    days += prevMonth.getDate();
  }

  // Adjust for negative months
  if (months < 0) {
    years--;
    months += 12;
  }

  let result = "";
  if (years) {
    result = result + `${years} years, `;
  }
  if (months) {
    result = result + `${months} months, `;
  }
  result = result + `${days} days`;

  return result;
}

export default class UpdateStatus extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      msg: "",
      toastColor: "",
      assetId: "",
      assetType: "",
      assetBrand: "",
      assetModel: "",
      assetUniqueIdentier: "",
      assetStatuss: [],
      status: "",
      startDate: "",
      endDate: "",
      errors: {},
      valid: true,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
    this.validate = this.validate.bind(this);
  }

  componentDidMount() {
    const urlParams = new URLSearchParams(window.location.search);
    let assetId = urlParams.get("assetId");
    if (!assetId) {
      assetId = this.props.assetId;
    }
    const assetType = this.props.assetType;
    const assetBrand = this.props.assetBrand;
    const assetModel = this.props.assetModel;
    const assetUniqueIdentier = this.props.assetUniqueIdentier;

    if (assetId) {
      this.setState({
        assetId,
        assetType,
        assetBrand,
        assetModel,
        assetUniqueIdentier,
      });
    } else {
      this.setState({
        msg: "No asset ID provided",
        toastColor: "danger",
      });
    }
    this.fetchDropdowns();
  }
  fetchDropdowns() {
     const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        loading: false,
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.location.href = `/?redirectUrl=${
        window.location.pathname + window.location.search
      }`;
      return;
    }
    axios
      .get(API + "/asset/getassetupdatestatuslist", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        const data = response.data || {};
        this.setState({
          assetStatuss: data});
      })
      .catch((error) => {
        console.error("Failed to load dropdowns:", error);
      });
  }
  handleChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value }, this.validate);
  }

  validate() {
    const s = this.state;
    let errors = {};
    let valid = true;

    if (!s.status || !s.status.trim()) {
      errors.status = "Status is required";
      valid = false;
    }
    if (!s.startDate || !s.startDate.trim()) {
      errors.startDate = "Start date is required";
      valid = false;
    }
    if (!s.endDate || !s.endDate.trim()) {
      errors.endDate = "End date is required";
      valid = false;
    }
    if (
      s.startDate &&
      s.endDate &&
      new Date(s.startDate) >= new Date(s.endDate)
    ) {
      errors.endDate = "End date must be after start date";
      valid = false;
    }

    this.setState({ errors, valid });
    return valid;
  }

  handleUpdate(e) {
    e.preventDefault();
    if (!this.validate()) {
      this.setState({
        msg: "Fix the errors above and try again.",
        toastColor: "danger",
      });
      return;
    }

    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.location.href = `/?redirectUrl=${
        window.location.pathname + window.location.search
      }`;
      return;
    }

    this.setState({ loading: true, msg: "", toastColor: "" });

    const request = {
      assetId: this.state.assetId,
      assetStatus: this.state.status,
      startDate: this.state.startDate,
      endDate: this.state.endDate,
    };

    axios
      .post(API + "/asset/updatestatus", request, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        if (response.data.success) {
          this.setState({
            msg: response.data.message || "Status updated successfully!",
            toastColor: "success",
            loading: false,
          });
          setTimeout(() => {
            this.props.closeAction();
            if (this.props.onSuccess) {
              this.props.onSuccess();
            }
          }, 2000);
        } else {
          this.setState({
            msg: response.data.message || "Update failed",
            toastColor: "danger",
            loading: false,
          });
        }
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.location.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        this.setState({
          msg:
            error?.response?.data?.message ||
            "Update failed. Please try again.",
          toastColor: "danger",
          loading: false,
        });
      });
  }

  render() {
    const s = this.state;
    let divMsg = null;
    if (s.msg) {
      divMsg = (
        <div
          className={
            s.toastColor === "success"
              ? "alert alert-success mx-7"
              : "alert alert-danger mx-7"
          }
        >
          {s.msg}
        </div>
      );
    }

    if (s.loading) {
      return (
        <Modal title="Update Status" footerContent={<></>}>
          <div className="w-100 h-10 overflow-hidden d-flex justify-content-center align-items-center">
            <Spinner className="" />
          </div>
        </Modal>
      );
    }


    return (
      <Modal
        title="Update Status"
        closeAction={this.props.closeAction}
        footerContent={
          <>
            {s.valid && s.status && (
              <button
                type="button"
                className="btn btn-primary disabled:cursor-not-allowed"
                disabled={!s.valid}
                onClick={this.handleUpdate}
              >
                Update
              </button>
            )}
            <button
              type="button"
              className="btn btn-primary"
              onClick={this.props.closeAction}
            >
              Close
            </button>
          </>
        }
      >
        <div className="h-100 w-100 d-flex flex-column">
          {divMsg}
            <div className="row">
                              <div className="col">
                                <b>{primaryLabelName(s.assetType)}: </b>
                                <span>{s.assetBrand}</span>
                              </div>
                              <div className="col">
                                <b>{secondaryLabelName(s.assetType)}: </b>
                                <span>{s.assetModel}</span>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col">
                                <b>{uniqueIdentifier1Name(s.assetType)}: </b>
                                <span>{s.assetUniqueIdentier}</span>
                              </div>
                            </div>

          <form
            className=" w-full"
            autoComplete="off"
            onSubmit={this.handleUpdate}
          >
            <div className="row">
              <div className="col">
                <div className="input-group">
                  <label className="input-group-text">Status</label>
                  <select
                    name="status"
                    className={`form-control ${
                      s.errors.status ? " !border-red-500" : ""
                    }`}
                    value={s.status}
                    onChange={this.handleChange}
                    required
                  >
                    <option value="">Select</option>
                    {s.assetStatuss.map((status) => (
                      <option key={status} value={status}>
                        {status}
                      </option>
                    ))}
                  </select>
                  {s.errors.status && (
                    <span className="input-group-error">{s.errors.status}</span>
                  )}
                </div>
              </div>
              <div className="col">
                <div className="input-group">
                  <label className="input-group-text">Start Date</label>
                  <input
                    name="startDate"
                    className={`form-control ${
                      s.errors.startDate ? " !border-red-500" : ""
                    }`}
                    type="date"
                    value={s.startDate}
                    onChange={this.handleChange}
                    required
                  />
                  {s.errors.startDate && (
                    <span className="input-group-error">
                      {s.errors.startDate}
                    </span>
                  )}
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col">
                <div className="input-group">
                  <label className="input-group-text">End Date</label>
                  <input
                    name="endDate"
                    className={`form-control ${
                      s.errors.endDate ? " !border-red-500" : ""
                    }`}
                    type="date"
                    value={s.endDate}
                    onChange={this.handleChange}
                    required
                  />
                  {s.errors.endDate && (
                    <span className="input-group-error">
                      {s.errors.endDate}
                    </span>
                  )}
                </div>
              </div>
              <div className="col h-10">
                <div className="h-100 d-flex align-items-end">
                  <b>Duration: </b>
                  <span>{calculateDuration(s.startDate, s.endDate)}</span>
                </div>
              </div>
            </div>
          </form>
        </div>
      </Modal>
    );
  }
}
